//temporarily putting this here until we figure out autogen'd clients
//@ts-nocheck
export default class ServiceClient {
  protected baseUrl: string;
  protected debugMode: boolean;
  constructor(baseUrl: string, debugMode = true) {
    this.baseUrl = baseUrl;
    this.debugMode = debugMode;
  }

  /**
   * Generic POST handler
   * @param endpoint - API endpoint relative to the base URL
   * @param request - Request object with `toBinary` method
   * @param responseType - Response type with a static `fromBinary` method
   */
  protected async Post<
    TRequest,
    TResponse extends { fromBinary: (bytes: Uint8Array) => TResponse },
  >(
    endpoint: string,
    request: TRequest,
    responseType: { new (): TResponse }
  ): Promise<TResponse> {
    if (this.debugMode) return this.textPost(endpoint, request, responseType);

    return this.binaryPost(endpoint, request, responseType);
  }

  /**
   * Generic Text GET handler
   * @param endpoint - API endpoint relative to the base URL
   * @param request - Request object with `toBinary` method
   * @param responseType - Response type with a static `fromBinary` method
   */
  protected async Get<TResponse>(
    endpoint: string,
    responseType: { new (): TResponse }
  ): Promise<TResponse> {
    return this.textGet(endpoint, responseType);
    //TODO: binary get?
  }

  protected async textGet<TResponse>(
    endpoint: string,
    responseType: { new (): TResponse }
  ): Promise<TResponse> {
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(
        `Request failed with status ${response.status}: ${response.statusText}`
      );
    }

    const responseData = await response.text();
    return responseType.fromJsonString(responseData);
  }
  /**
   * Generic binary POST handler
   * @param endpoint - API endpoint relative to the base URL
   * @param request - Request object with `toBinary` method
   * @param responseType - Response type with a static `fromBinary` method
   */
  protected async binaryPost<
    TRequest,
    TResponse extends { fromBinary: (bytes: Uint8Array) => TResponse },
  >(
    endpoint: string,
    request: TRequest,
    responseType: { new (): TResponse }
  ): Promise<TResponse> {
    const binaryData = (request as any).toBinary();
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: 'POST',
      body: binaryData,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    });

    if (!response.ok) {
      throw new Error(
        `Request failed with status ${response.status}: ${response.statusText}`
      );
    }

    const responseData = await response.arrayBuffer();
    return responseType.fromBinary(new Uint8Array(responseData));
  }
  protected async textPost<
    TRequest,
    TResponse extends { fromBinary: (bytes: Uint8Array) => TResponse },
  >(
    endpoint: string,
    request: TRequest,
    responseType: { new (): TResponse }
  ): Promise<TResponse> {
    const binaryData = (request as any).toJsonString();
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: 'POST',
      body: binaryData,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(
        `Request failed with status ${response.status}: ${response.statusText}`
      );
    }

    const responseData = await response.text();
    return responseType.fromJsonString(responseData);
  }
}
